export const flattenObject = (obj) => {
  let result = {};
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      // Recursively flatten nested objects
      if (key === "mawp") {
        result[key] = `${obj[key].mawpvalue || "__"} PSI @ ${
          obj[key].mawpunit || "__"
        } °F`;
      } else if (key === "mdmt") {
        result[key] = `${obj[key].mdmtunit || "__"} °F @ ${
          obj[key].mdmtvalue || "__"
        } PSI`;
      } else {
        result = {
          ...result,
          ...flattenObject(obj[key]),
        };
      }
    } else {
      // Add units for specific fields roomSqFt
      if (
        [
          "SuctiontempF",
          "dischargetempF",
          "room_temp",
          "designTd",
          "actualSuctionTemp",
          "condensingTemp",
        ].includes(key) &&
        obj[key] !== ""
      ) {
        result[key] = `${obj[key]}°F`;
      } else if (
        [
          "SuctiontempPsig",
          "dischargepressureF",
          "condensingPressure",
        ].includes(key) &&
        obj[key] !== ""
      ) {
        result[key] = `${obj[key]} PSIG`;
      } else if (["oilCoolingHeatRejection"].includes(key) && obj[key] !== "") {
        result[key] = `${obj[key]} BTU/hr`;
      } else if (["roomSqFt"].includes(key) && obj[key] !== "") {
        result[key] = `${obj[key]} SqFt`;
      } else {
        result[key] = obj[key];
      }
    }
  }
  const voc = obj?.opCon?.volumetricOperatingCapacity || "__";
  const vfv = obj?.opCon?.volumeFillValue || "__";
  const vocp = obj?.opCon?.volumetricOperatingCapacityPhase
    ? obj?.opCon?.volumetricOperatingCapacityPhase === "LiqVap"
      ? "Liq+Vap"
      : obj?.opCon?.volumetricOperatingCapacityPhase
    : "__";
  result.volumetricOperatingCapacity = `${vocp}/${voc} lbs @ ${vfv}% Fill`;
  return result;
};

// Dataform Readonly: To get static field name concerning the eng object
export const getStaticFormFieldNames = (engObj) => {
  return [
    { fieldName: "Make", fieldKey: "make" },
    { fieldName: "Model", fieldKey: "model" },
    { fieldName: "Serial", fieldKey: "serial" },
    { fieldName: "Order", fieldKey: "order" },
    { fieldName: "Equipment ID  *", fieldKey: "plantID" },
    { fieldName: "NBN", fieldKey: "nbn" },
    { fieldName: "Year Built", fieldKey: "yearBuilt" },
    { fieldName: "MAWP", fieldKey: "mawp" },
    { fieldName: "MDMT", fieldKey: "mdmt" },
    { fieldName: "Base MBH", fieldKey: "baseMbh" },
    { fieldName: "Discharge Pressure Unit", fieldKey: "dischargepressureUnit" },
    { fieldName: "Length/ Height", fieldKey: "lengthHeight" },
    { fieldName: "Capacity (Gallon Capacity)", fieldKey: "capacityGC" },
    { fieldName: "Total Jacket Volume", fieldKey: "totalJacketVolume" },
    { fieldName: "Diameter", fieldKey: "diameter" },
    { fieldName: "Equipment Description", fieldKey: "equipmentName" },
    { fieldName: "Room Name", fieldKey: "roomName" },
    { fieldName: "Room Sq ft", fieldKey: "roomSqFt" },
    { fieldName: "Room Temperature", fieldKey: "room_temp" },
    { fieldName: "Suction Temp *", fieldKey: "SuctiontempF" },
    { fieldName: "Suction Pressure *", fieldKey: "SuctiontempPsig" },
    { fieldName: "Suction Temp *", fieldKey: "SuctiontempF" },
    { fieldName: "Discharge Temp *", fieldKey: "dischargetempF" },
    { fieldName: "Condensing Temp *", fieldKey: "condensingTemp" },
    { fieldName: "Discharge Pressure *", fieldKey: "dischargepressureF" },
    { fieldName: "Condensing Pressure *", fieldKey: "dischargepressureF" },
    { fieldName: "Suction Pressure *", fieldKey: "suctionpressureunit" },
    { fieldName: "Sq Ft per Ton", fieldKey: "sqftperton" },
    {
      fieldName: "Discharge Pressure Unit *",
      fieldKey: "dischargepressureUnit",
    },
    { fieldName: "Side", fieldKey: "side" },
    { fieldName: "Design TD", fieldKey: "designTd" },
    {
      fieldName: "Oil Cooling Heat Rejection",
      fieldKey: "oilCoolingHeatRejection",
    },
    {
      fieldName: "Orientation (Vertical or Horizontal)",
      fieldKey: "orientation",
    },
    {
      fieldName: `${
        engObj === "Vessels" ? "Operating " : "Actual Suction "
      }Temperature *`,
      fieldKey: "actualSuctionTemp",
    },
    //{ fieldName: 'Operating Capacity', fieldKey: 'operatingCapacity' },
    {
      fieldName: "Volumetric Operating Capacity",
      fieldKey: "volumetricOperatingCapacity",
    },
    { fieldName: "Condensing Temperature", fieldKey: "condensingTemperature" },
    { fieldName: "Condensing Pressure", fieldKey: "condensingPressure" },
  ];
};

// Dataform Readonly: To get static form fields by eng object
export const staticFormFieldsbyEngObj = {
  "Heat Exchanger": [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "SuctiontempF",
    "SuctiontempPsig",
    "side",
  ],
  Vessels: [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "nbn",
    "mdmt",
    "mawp",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "actualSuctionTemp",
    "operatingCapacity",
    "volumetricOperatingCapacity",
  ],
  "Air Handler": [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "roomSqFt",
    "room_temp",
    "actualSuctionTemp",
    "sqftperton",
    "designTd",
  ],
  "Silos and Tanks": [
    "make",
    "model",
    "serial",
    "plantID",
    "yearBuilt",
    "mdmt",
    "mawp",
    "lengthHeight",
    "capacityGC",
    "totalJacketVolume",
    "diameter",
    "orientation",
    "equipmentName",
    "roomName",
  ],
  Compressor: [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "SuctiontempF",
    "SuctiontempPsig",
    "dischargetempF",
    "dischargepressureF",
    "oilCoolingHeatRejection",
    "condensingTemp",
    "condensingPressure",
  ],
  Evaporator: [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "roomSqFt",
    "room_temp",
    "actualSuctionTemp",
    "sqftperton",
    "designTd",
  ],
  Condenser: [
    "make",
    "model",
    "serial",
    "baseMbh",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "condensingTemperature",
    "condensingPressure",
  ],
  "Valve Station": [
    "make",
    "model",
    "serial",
    "order",
    "plantID",
    "yearBuilt",
    "equipmentName",
    "roomName",
    "roomSqFt",
    "room_temp",
  ],
};

// Dataform Readonly: Retrieves the field name associated with the given field key.
export const getFieldNameByKey = (staticFields, engg_object_name) => {
  const result = {};
  for (const fieldKey in staticFields) {
    const engObjectFields = staticFormFieldsbyEngObj[engg_object_name];
    if (engObjectFields?.includes(fieldKey)) {
      const field = getStaticFormFieldNames(engg_object_name)?.find(
        (item) => item.fieldKey === fieldKey
      );
      if (field) {
        result[field.fieldName] = staticFields[fieldKey];
      }
    }
  }
  return result;
};

export const getFieldsForDataformReadyOnly = (jsonData, engg_object_name) => {
  const { staticForm, elements } = jsonData;
  let staticFields = flattenObject(staticForm);
  staticFields = getFieldNameByKey(staticFields, engg_object_name);
  const dynamicFields = {};

  elements
    ?.filter((el) => el) // remove null/undefined
    .forEach(({ heading, fields }) => {
      if (
        ![
          "Overlay Parameters",
          "LAD Config Parameters",
          "LAD Config Parameters for Valve Station",
        ].includes(heading)
      ) {
        fields?.forEach(
          ({ fieldtype, fieldname, value, unit, optionsData, visiblewhen }) => {
            if (fieldtype === "select") {
              optionsData?.forEach((item) => {
                if (item?.value === value) {
                  value = item?.label;
                }
              });
            }

            if (fieldname === "Superheat") {
              const conditionValue =
                visiblewhen.length > 0
                  ? Object.values(visiblewhen[0])[0]
                  : null;
              if (conditionValue) {
                fieldname = `${fieldname} (${conditionValue})`;
              }
            }

            if (
              fieldname === "Operating Capacity" &&
              engg_object_name === "Vessels"
            ) {
              fieldname = `${fieldname} (${unit})`;
            }

            if (fieldname === "Base MBH" && engg_object_name === "Condenser") {
              fieldname = `${fieldname} (${unit})`;
            }

            if (
              fieldname === "Reheat Load" ||
              fieldname === "Reheat Connected"
            ) {
              const reheatOptionField = fields.find(
                (f) => f.fieldname === "Reheat"
              );
              if (reheatOptionField && reheatOptionField.value === "no") {
                value = "";
              } else if (fieldname === "Reheat Load" && !value) {
                const reheatField = fields.find(
                  (f) => f.fieldname === "Reheat Connected"
                );
                if (reheatField && reheatField.value === "no") {
                  value = "";
                }
              }
            }

            if (
              (fieldname === "SST" || fieldname === "SDT") &&
              unit === "" &&
              value !== ""
            ) {
              value = `${value} °F`;
            }

            if (fieldname === "Add economizer capacity") {
              value = value ? "Yes" : "No";
            }

            dynamicFields[fieldname] =
              value && unit === "˚F"
                ? `${value} °F`
                : value && unit
                ? `${value}${unit}`
                : value;
          }
        );
      } else if (
        heading === "LAD Config Parameters" ||
        heading === "LAD Config Parameters for Valve Station"
      ) {
        fields?.forEach(({ fieldname, value, unit }) => {
          if (["System Designation", "Group"].includes(fieldname)) {
            dynamicFields[fieldname] =
              value && unit ? `${value} ${unit}` : value;
          }
        });
      }
    });

  return { ...staticFields, ...dynamicFields };
};
